<template>
    <div>
        <transition name="fade" enter-active-class="animated fadeIn"
                    leave-active-class="animated fadeOut"
                    :duration="300">
            <div class="cover-layer" v-show="isHotCityShow"></div>
        </transition>
        <transition name="bounce" enter-active-class="animated bounceInUp"
                    leave-active-class="animated fadeOut"
                    :duration="500">
            <div :class="productType=='256'?'m-search-content m-search-content-homestay':'m-search-content'" v-show="isHotCityShow" ref="hotCity">
                <div v-if="productType!='256'">
                    <div class="info">全球城市/酒店/地标，支持中文/英文/拼音/首字母搜索</div>
                    <ul class="content-list">
                        <li class="list-item">
                            <div class="list-label">热门区域</div>
                            <div class="list-content">
                                <div @click="selectHotel({N:'香港',I:'3201',F:'1'})"><span>香港</span></div>
                                <div @click="selectHotel({N:'澳门',I:'3301',F:'1'})"><span>澳门</span></div>
                                <div @click="selectHotel({N:'北京',I:'0101',F:'1'})"><span>北京</span></div>
                                <div @click="selectHotel({N:'上海',I:'0201',F:'1'})"><span>上海</span></div>
                                <div @click="selectHotel({N:'广州',I:'2001',F:'1'})"><span>广州</span></div>
                                <div @click="selectHotel({N:'深圳',I:'2003',F:'1'})"><span>深圳</span></div>
                                <div @click="selectHotel({N:'杭州',I:'1201',F:'1'})"><span>杭州</span></div>
                                <div @click="selectHotel({N:'成都',I:'2301',F:'1'})"><span>成都</span></div>
                                <div @click="selectHotel({N:'厦门',I:'1401',F:'1'})"><span>厦门</span></div>
                                <div @click="selectHotel({N:'三亚',I:'2201',F:'1'})"><span>三亚</span></div>
                                <div @click="selectHotel({N:'台北',I:'EAN_180030',F:'0'})"><span>台北</span></div>
                                <div @click="selectHotel({N:'曼谷',I:'EAN_178236',F:'0'})"><span>曼谷</span></div>
                                <div @click="selectHotel({N:'普吉岛',I:'EAN_6046393',F:'0'})"><span>普吉岛</span></div>
                                <div @click="selectHotel({N:'新加坡',I:'EAN_3168',F:'0'})"><span>新加坡</span></div>
                                <div @click="selectHotel({N:'首尔',I:'EAN_178308',F:'0'})"><span>首尔</span></div>
                                <div @click="selectHotel({N:'清迈',I:'EAN_6056197',F:'0'})"><span>清迈</span></div>
                                <div @click="selectHotel({N:'吉隆坡',I:'EAN_180008',F:'0'})"><span>吉隆坡</span></div>
                                <div @click="selectHotel({N:'东京',I:'EAN_179900',F:'0'})"><span>东京</span></div>
                            </div>
                        </li>
                        <li class="list-item">
                            <div class="list-label">亚洲及中东</div>
                            <div class="list-content">
                                <div @click="selectHotel({N:'沙巴',I:'EAN_11188',F:'0'})"><span>沙巴</span></div>
                                <div @click="selectHotel({N:'大阪',I:'EAN_179897',F:'0'})"><span>大阪</span></div>
                                <div @click="selectHotel({N:'京都',I:'EAN_6131486',F:'0'})"><span>京都</span></div> 
                                <div @click="selectHotel({N:'北海道',I:'EAN_6048149',F:'0'})"><span>北海道</span></div>
                                <div @click="selectHotel({N:'苏梅岛',I:'EAN_3657',F:'0'})"><span>苏梅岛</span></div>
                                <div @click="selectHotel({N:'甲米',I:'EAN_602231',F:'0'})"><span>甲米</span></div>
                                <div @click="selectHotel({N:'巴厘岛',I:'EAN_602651',F:'0'})"><span>巴厘岛</span></div>
                                <div @click="selectHotel({N:'济州岛',I:'EAN_850',F:'0'})"><span>济州岛</span></div>
                                <div @click="selectHotel({N:'胡志明市',I:'EAN_178262',F:'0'})"><span>胡志明市</span></div>
                                <div @click="selectHotel({N:'河内',I:'EAN_1428',F:'0'})"><span>河内</span></div>
                                <div @click="selectHotel({N:'芽庄',I:'EAN_6054439',F:'0'})"><span>芽庄</span></div>
                                <div @click="selectHotel({N:'岘港',I:'EAN_974',F:'0'})"><span>岘港</span></div>
                                <div @click="selectHotel({N:'马尼拉',I:'EAN_178282',F:'0'})"><span>马尼拉</span></div>
                                <div @click="selectHotel({N:'槟城',I:'EAN_2766',F:'0'})"><span>槟城</span></div>
                                <div @click="selectHotel({N:'兰卡威',I:'EAN_6126505',F:'0'})"><span>兰卡威</span></div>
                                <div @click="selectHotel({N:'暹粒',I:'EAN_2975',F:'0'})"><span>暹粒</span></div>
                                <div @click="selectHotel({N:'金边',I:'EAN_6191801',F:'0'})"><span>金边</span></div>
                                <div @click="selectHotel({N:'阿布扎比',I:'EAN_453',F:'0'})"><span>阿布扎比</span></div>
                                <div @click="selectHotel({N:'迪拜',I:'EAN_553248635974547000',F:'0'})"><span>迪拜</span></div>

                            </div>
                        </li>
                        <li class="list-item">
                            <div class="list-label">欧洲</div>
                            <div class="list-content">
                                <div @click="selectHotel({N:'巴黎',I:'EAN_179898',F:'0'})"><span>巴黎</span></div>
                                <div @click="selectHotel({N:'伦敦',I:'EAN_178279',F:'0'})"><span>伦敦</span></div>
                                <div @click="selectHotel({N:'米兰',I:'EAN_180012',F:'0'})"><span>米兰</span></div>
                                <div @click="selectHotel({N:'法兰克福',I:'EAN_179894',F:'0'})"><span>法兰克福</span></div>
                                <div @click="selectHotel({N:'罗马',I:'EAN_179899',F:'0'})"><span>罗马</span></div>
                                <div @click="selectHotel({N:'巴塞罗那',I:'EAN_179992',F:'0'})"><span>巴塞罗那</span></div>
                                <div @click="selectHotel({N:'慕尼黑',I:'EAN_179896',F:'0'})"><span>慕尼黑</span></div>
                                <div @click="selectHotel({N:'莫斯科',I:'EAN_178289',F:'0'})"><span>莫斯科</span></div>
                                <div @click="selectHotel({N:'圣彼得堡',I:'EAN_180029',F:'0'})"><span>圣彼得堡</span></div>
                                <div @click="selectHotel({N:'阿姆斯特丹',I:'EAN_178229',F:'0'})"><span>阿姆斯特丹</span></div>
                                <div @click="selectHotel({N:'马德里',I:'EAN_178281',F:'0'})"><span>马德里</span></div>
                                <div @click="selectHotel({N:'佛罗伦萨',I:'EAN_1222',F:'0'})"><span>佛罗伦萨</span></div>
                                <div @click="selectHotel({N:'威尼斯',I:'EAN_179981',F:'0'})"><span>威尼斯</span></div>
                                <div @click="selectHotel({N:'布拉格',I:'EAN_180014',F:'0'})"><span>布拉格</span></div>
                                <div @click="selectHotel({N:'维也纳',I:'EAN_178316',F:'0'})"><span>维也纳</span></div>
                                <div @click="selectHotel({N:'柏林',I:'EAN_179892',F:'0'})"><span>柏林</span></div>
                                <div @click="selectHotel({N:'日内瓦',I:'EAN_180003',F:'0'})"><span>日内瓦</span></div>
                                <div @click="selectHotel({N:'雅典',I:'EAN_178231',F:'0'})"><span>雅典</span></div>
                            </div>
                        </li>
                        <li class="list-item">
                            <div class="list-label">美洲</div>
                            <div class="list-content">
                                <div @click="selectHotel({N:'洛杉矶',I:'EAN_178280',F:'0'})"><span>洛杉矶</span></div>
                                <div @click="selectHotel({N:'拉斯维加斯',I:'EAN_178276',F:'0'})"><span>拉斯维加斯</span></div>
                                <div @click="selectHotel({N:'纽约',I:'EAN_178293',F:'0'})"><span>纽约</span></div>
                                <div @click="selectHotel({N:'旧金山',I:'EAN_178305',F:'0'})"><span>旧金山</span></div>
                                <div @click="selectHotel({N:'温哥华',I:'EAN_178315',F:'0'})"><span>温哥华</span></div>
                                <div @click="selectHotel({N:'欧胡岛',I:'EAN_180077',F:'0'})"><span>欧胡岛</span></div>
                                <div @click="selectHotel({N:'塞班岛',I:'EAN_6142849',F:'0'})"><span>塞班岛</span></div>
                                <div @click="selectHotel({N:'芝加哥',I:'EAN_178248',F:'0'})"><span>芝加哥</span></div>
                                <div @click="selectHotel({N:'多伦多',I:'EAN_178314',F:'0'})"><span>多伦多</span></div>
                                <div @click="selectHotel({N:'波士顿',I:'EAN_178239',F:'0'})"><span>波士顿</span></div>
                                <div @click="selectHotel({N:'圣地亚哥',I:'EAN_3073',F:'0'})"><span>圣地亚哥</span></div>
                                <div @click="selectHotel({N:'奥兰多',I:'EAN_178294',F:'0'})"><span>奥兰多</span></div>
                                <div @click="selectHotel({N:'华盛顿',I:'EAN_178318',F:'0'})"><span>华盛顿</span></div>
                                <div @click="selectHotel({N:'西雅图',I:'EAN_178307',F:'0'})"><span>西雅图</span></div>
                                <div @click="selectHotel({N:'迈阿密',I:'EAN_178286',F:'0'})"><span>迈阿密</span></div>
                            </div>
                        </li>
                        <li class="list-item">
                            <div class="list-label">大洋洲</div>
                            <div class="list-content">
                                <div @click="selectHotel({N:'悉尼',I:'EAN_178312',F:'0'})"><span>悉尼</span></div>
                                <div @click="selectHotel({N:'墨尔本',I:'EAN_178283',F:'0'})"><span>墨尔本</span></div>
                                <div @click="selectHotel({N:'奥克兰',I:'EAN_178233',F:'0'})"><span>奥克兰</span></div>
                                <div @click="selectHotel({N:'黄金海岸',I:'EAN_180064',F:'0'})"><span>黄金海岸</span></div>
                                <div @click="selectHotel({N:'凯恩斯',I:'EAN_553248635404168639',F:'0'})"><span>凯恩斯</span></div>
                                <div @click="selectHotel({N:'布里斯班',I:'EAN_179993',F:'0'})"><span>布里斯班</span></div>
                                <div @click="selectHotel({N:'皇后镇',I:'EAN_180018',F:'0'})"><span>皇后镇</span></div>
                                <div @click="selectHotel({N:'基督城',I:'EAN_179996',F:'0'})"><span>基督城</span></div>
                                <div @click="selectHotel({N:'阿德莱德',I:'EAN_6051330',F:'0'})"><span>阿德莱德</span></div>
                                <div @click="selectHotel({N:'珀斯',I:'EAN_6354222',F:'0'})"><span>珀斯</span></div>
                            </div>
                        </li>
                        <li class="list-item">
                            <div class="list-label">非洲</div>
                            <div class="list-content">
                                <div @click="selectHotel({N:'卡萨布兰卡',I:'EAN_6084755',F:'0'})"><span>卡萨布兰卡</span></div>
                                <div @click="selectHotel({N:'马拉喀什',I:'EAN_6084756',F:'0'})"><span>马拉喀什</span></div>
                                <div @click="selectHotel({N:'毛里求斯',I:'EAN_115',F:'0'})"><span>毛里求斯</span></div>
                                <div @click="selectHotel({N:'开罗',I:'EAN_178243',F:'0'})"><span>开罗</span></div>
                                <div @click="selectHotel({N:'约翰内斯堡',I:'EAN_6051471',F:'0'})"><span>约翰内斯堡</span></div>
                                <div @click="selectHotel({N:'开普敦',I:'EAN_6046820',F:'0'})"><span>开普敦</span></div>
                                <div @click="selectHotel({N:'内罗毕',I:'EAN_178290',F:'0'})"><span>内罗毕</span></div>
                                <div @click="selectHotel({N:'马埃堡',I:'EAN_6047394',F:'0'})"><span>马埃堡</span></div>
                                <div @click="selectHotel({N:'塞舌尔',I:'EAN_159',F:'0'})"><span>塞舌尔</span></div>
                                <div @click="selectHotel({N:'德班',I:'EAN_3000454424',F:'0'})"><span>德班</span></div>
                            </div>
                        </li>
                        <li class="list-item">
                            <div class="list-label">热门海岛</div>
                            <div class="list-content">
                                <div @click="selectHotel({N:'富国岛',I:'EAN_6141655',F:'0'})"><span>富国岛</span></div>
                                <div @click="selectHotel({N:'冲绳',I:'EAN_10805',F:'0'})"><span>冲绳</span></div>
                                <div @click="selectHotel({N:'皮皮岛',I:'EAN_9409',F:'0'})"><span>皮皮岛</span></div>
                                <div @click="selectHotel({N:'长滩岛',I:'EAN_601371',F:'0'})"><span>长滩岛</span></div>
                                <div @click="selectHotel({N:'民丹岛',I:'EAN_9028',F:'0'})"><span>民丹岛</span></div>
                                <div @click="selectHotel({N:'象岛',I:'EAN_6125740',F:'0'})"><span>象岛</span></div>
                                <div @click="selectHotel({N:'热浪岛',I:'EAN_6055947',F:'0'})"><span>热浪岛</span></div>
                                <div @click="selectHotel({N:'塞班岛',I:'EAN_6142849',F:'0'})"><span>塞班岛</span></div>
                                <div @click="selectHotel({N:'关岛',I:'EAN_70',F:'0'})"><span>关岛</span></div>
                                <div><span @click="selectHotel({N:'马尔代夫',I:'EAN_109',F:'0'})">马尔代夫</span></div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div v-if="productType=='256'">
                    <div class="info">热门城市</div>
                    <ul class="content-list">
                        <li class="list-item">
                            <div class="list-content">
                                <div @click="selectHotel({F:'1',N:'北京',I:'0101'})"><span>北京</span></div>
                                <div @click="selectHotel({F:'1',N:'上海',I:'0201'})"><span>上海</span></div>
                                <div @click="selectHotel({F:'1',N:'广州',I:'2001'})"><span>广州</span></div>
                                <div @click="selectHotel({F:'1',N:'深圳',I:'2003'})"><span>深圳</span></div>
                                <div @click="selectHotel({F:'1',N:'杭州',I:'1201'})"><span>杭州</span></div>
                                <div @click="selectHotel({F:'1',N:'成都',I:'2301'})"><span>成都</span></div>
                                <div @click="selectHotel({F:'1',N:'厦门',I:'1401'})"><span>厦门</span></div>
                                <div @click="selectHotel({F:'1',N:'香港',I:'3201'})"><span>香港</span></div>
                                <div @click="selectHotel({F:'1',N:'澳门',I:'3301'})"><span>澳门</span></div>
                                <div @click="selectHotel({F:'1',N:'三亚',I:'2201'})"><span>三亚</span></div>
                                <div @click="selectHotel({F:'1',N:'秦皇岛',I:'0503'})"><span>秦皇岛</span></div>
                                <div @click="selectHotel({F:'1',N:'青岛',I:'1601'})"><span>青岛</span></div>
                                <div @click="selectHotel({F:'1',N:'南京',I:'1101'})"><span>南京</span></div>
                                <div @click="selectHotel({F:'1',N:'重庆',I:'0401'})"><span>重庆</span></div>
                                <div @click="selectHotel({F:'1',N:'大理',I:'2505'})"><span>大理</span></div>
                                <div @click="selectHotel({F:'1',N:'大连',I:'0801'})"><span>大连</span></div>
                                <div @click="selectHotel({F:'1',N:'西安',I:'2701'})"><span>西安</span></div>
                                <div @click="selectHotel({F:'1',N:'苏州',I:'1102'})"><span>苏州</span></div>
                                <div @click="selectHotel({F:'1',N:'昆明',I:'2501'})"><span>昆明</span></div>
                                <div @click="selectHotel({F:'1',N:'桂林',I:'2101'})"><span>桂林</span></div>
                                <div @click="selectHotel({F:'1',N:'济南',I:'1602'})"><span>济南</span></div>
                                <div @click="selectHotel({F:'1',N:'丽江',I:'2503'})"><span>丽江</span></div>
                                <div @click="selectHotel({F:'1',N:'黄山',I:'1302'})"><span>黄山</span></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "HotCity",
        props: {
            isHotCityShow: {
                type: Boolean,
                default: false
            },
            productType: {
                type: String,
                default: '4'
            }
        },
        data: function () {
            return {}
        },
        mounted() {
            this.addCloseListener();
        },
        methods: {
            selectHotel(obj) {
                this.$emit('select', obj)
            },
            addCloseListener() {
                let that = this;
                document.addEventListener('click', that.onClick,false);
            },
            onClick(e){
                if (e.target.className == 'searchAll' || this.$refs.hotCity && this.$refs.hotCity.contains(e.target)) return;
                this.$emit('select')
            }
        },
        destroyed(){
            document.removeEventListener('click', this.onClick,false)
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/common/cmpnt/hotCity/HotCity.vue